export default "__VITE_ASSET__ByKtiqmR__"